import { VeeqoLogo, ColorVariant, LogoVariant } from '@veeqo/ui';
import { useEffect } from 'react';
import { Wrapper, Separator } from './styling/styled';
import { usePolling } from './utils/usePolling';
import { ContentType } from './content';
import { Background, BackgroundVariant } from './component/Background';
import { Card, CardVariant } from './component/Card/Card';
import { Footer } from './component/Footer';

export const Landing = ({
  backgroundVariant,
  logoVariant,
  colorVariant,
  cardVariant,
  contentType,
  entryType,
  footer,
}: {
  backgroundVariant?: BackgroundVariant;
  logoVariant?: LogoVariant;
  colorVariant?: ColorVariant;
  cardVariant?: CardVariant;
  contentType: ContentType;
  entryType: 'landing' | 'lwsc' | 'insc';
  footer?: boolean;
}) => {
  const { error, ready, jobId } = usePolling(entryType);

  useEffect(() => {
    window.vqMetrics.logPageLoad();
  }, []);

  return (
    <Background backgroundVariant={backgroundVariant}>
      <Wrapper>
        <VeeqoLogo
          variant={logoVariant}
          colorVariant={colorVariant}
          style={{ width: '208px', height: '87px', margin: 'auto' }}
        />
        <Card
          cardVariant={cardVariant}
          error={error}
          ready={ready}
          contentType={contentType}
          jobId={jobId}
        />
        <Separator />
        {footer && <Footer contentType={contentType} />}
      </Wrapper>
    </Background>
  );
};
